import { render, staticRenderFns } from "./AddNum.vue?vue&type=template&id=0d736753&scoped=true&"
import script from "./AddNum.vue?vue&type=script&lang=js&"
export * from "./AddNum.vue?vue&type=script&lang=js&"
import style0 from "./AddNum.vue?vue&type=style&index=0&id=0d736753&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d736753",
  null
  
)

export default component.exports